import type { CompanyInfoDTO } from '@interfaces/referrfer';
import { atom } from 'jotai';

const fallback: CompanyInfoDTO = {
  companyName: '',
  managerName: '',
  managerEmail: '',
  managerPhone: '',
  loginLogo: '',
  loginBackground: '',
  loginColor: '',
  drmYn: false,
};

export const companyInfo = atom<CompanyInfoDTO>(fallback);
